import {
  dataModuleName,
  DataModuleName,
  DataStartedAt,
  dataStartedAt,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataModulesListRequestDTO {
  private static validation = Validate.compile(
    DataModulesListRequestDTO.validationSchema()
  );

  constructor(readonly data: DataModulesListRequestDTORaw) {
    Validate.assert(DataModulesListRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['page'],
      properties: {
        moduleName: dataModuleName,
        page: {
          type: 'number',
          minimum: 1,
        },
        from: dataStartedAt,
        to: dataStartedAt,
      },
    };
  }
}

interface DataModulesListRequestDTORaw {
  moduleName?: DataModuleName;
  page: number;
  from?: DataStartedAt;
  to?: DataStartedAt;
}
